
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Form } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import { Send } from "lucide-react";
import { FormFields } from "./contact-form/FormFields";
import { useContactForm } from "./contact-form/useContactForm";
import { ContactFormDialogProps } from "./contact-form/types";

export const ContactFormDialog = ({ 
  open, 
  onOpenChange, 
  productTitle,
  productId,
  professionalId 
}: ContactFormDialogProps) => {
  const { form, isLoading, onSubmit } = useContactForm(
    productId,
    professionalId,
    () => onOpenChange(false)
  );

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Formulaire de contact</DialogTitle>
          <DialogDescription>
            {productTitle ? `Pour le produit : ${productTitle}` : "Remplissez le formulaire ci-dessous pour nous contacter"}
          </DialogDescription>
        </DialogHeader>
        
        <Form {...form}>
          <form onSubmit={onSubmit} className="space-y-4">
            <FormFields form={form} />

            <div className="flex justify-end gap-4 pt-4">
              <Button
                type="button"
                variant="outline"
                onClick={() => onOpenChange(false)}
              >
                Annuler
              </Button>
              <Button type="submit" disabled={isLoading}>
                <Send className="mr-2 h-4 w-4" />
                {isLoading ? "Envoi..." : "Envoyer"}
              </Button>
            </div>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  );
};
